import {
  pgTable,
  uuid,
  text,
  boolean,
  timestamp,
  index,
  uniqueIndex,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

/**
 * Notification Preferences — per-person, per-category channel opt-in/opt-out.
 *
 * Channels: email, sms, push, in_app (columns, not rows — one row per category).
 * Categories: marketing, transactional, booking, review, workflow.
 *
 * Default: all channels enabled. Person opts OUT of specific channels/categories.
 * Marketing email is ALSO gated by emailPreferences.unsubscribedAt (GDPR).
 */
export const notificationPreferences = pgTable(
  "notification_preferences",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    personId: uuid("person_id").notNull(),
    category: text("category").notNull(),
      // "marketing" | "transactional" | "booking" | "review" | "workflow"
    emailEnabled: boolean("email_enabled").notNull().default(true),
    smsEnabled: boolean("sms_enabled").notNull().default(true),
    pushEnabled: boolean("push_enabled").notNull().default(true),
    inAppEnabled: boolean("in_app_enabled").notNull().default(true),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  },
  (table) => [
    // One preference row per person per category
    uniqueIndex("uq_notif_pref_person_category").on(
      table.tenantId,
      table.personId,
      table.category,
    ),
    // Lookup: all preferences for a person
    index("idx_notif_pref_person").on(table.tenantId, table.personId),
  ],
);
